module.exports = __webpack_public_path__ + "img/lesson_07.07644fc1.jpg";